var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('img',{staticStyle:{"object-fit":"contain","width":"400px"},attrs:{"src":_vm.url}}),_c('img',{staticStyle:{"object-fit":"contain","width":"400px"},attrs:{"src":_vm.baseUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }